var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useCallback } from "react";
import { typography } from "../../shared/theme";
import { makeStyles, InputAdornment } from "@material-ui/core";
import { FTLTextField } from "../FTLTextField";
import { FTLIconButton } from "../FTLIconButton";
import { ClearIcon, SearchIcon } from "../icons";
export const FTLSearchField = (_a) => {
    var { onChange, disabled = false, value = "", iconSize = "default" } = _a, otherProps = __rest(_a, ["onChange", "disabled", "value", "iconSize"]);
    const classes = useStyles();
    const [valueState, setValue] = useState(value);
    useEffect(() => {
        onChange && onChange(valueState);
    }, [valueState]);
    const resetValue = useCallback(() => setValue(""), []);
    return (React.createElement(FTLTextField, Object.assign({ type: "text", size: "small", value: valueState, className: classes.root, onChange: (e) => {
            setValue(e.target.value);
        }, disabled: disabled, InputProps: {
            endAdornment: (React.createElement(InputAdornment, { position: "end" },
                React.createElement(FTLIconButton, { disableRipple: true, tabIndex: -1, disabled: disabled, disableBackground: true, className: classes.iconButton, color: valueState.length === 0 ? undefined : "tertiary" }, valueState.length === 0 ? (React.createElement(SearchIcon, null)) : (React.createElement(ClearIcon, { onClick: () => {
                        resetValue();
                    }, className: iconSize === "small" ? classes.smallIcon : "" }))))),
        } }, otherProps)));
};
const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: "160px",
        "& input::placeholder": {
            color: "#6C7889",
            opacity: 1,
        },
        "& input": {
            marginRight: "27px",
        },
    },
    formControl: {
        // minWidth: "240px",
        minWidth: "160px",
        maxWidth: "240px",
        // margin: theme.spacing(1),
        "& > div": {
            marginTop: theme.spacing(2),
            backgroundColor: "#F9FAFA",
            // '',
            "&.Mui-focused fieldset": {
                border: "2px solid #66A6FF !important",
            },
            "&:hover fieldset": {
                backgroundColor: "#EBEDF0",
                border: "1px solid",
                borderColor: "#C4CBD4 !important",
            },
        },
    },
    label: Object.assign({ color: theme.palette.text.tertiary, position: "static", transform: "none" }, typography.supportedTags.h5),
    rootSelect: Object.assign(Object.assign({ padding: "10px 12px" }, typography.unsupportedSemanticTags.listItemText), { zIndex: 1 }),
    icon: {},
    select: {
    // "&:focus": {
    //   border: "2px solid #66A6FF",
    // },
    },
    focus: {
        color: "#627084 !important",
    },
    menu: {},
    menuList: {
        "& > li": Object.assign({ padding: "6px 12px" }, typography.unsupportedSemanticTags.listItemText),
    },
    placeholder: {
        color: theme.palette.text.placeholder,
    },
    cancelIcon: {
        zIndex: 1,
        right: "32px",
        pointerEvents: "initial",
        cursor: "pointer",
        top: "calc(50% - 8px)",
    },
    disabled: {
        backgroundColor: "#F3F4F6",
    },
    iconButton: {
        "&:hover svg": {
            fill: theme.palette.icon.secondary,
        },
    },
    smallIcon: {
        width: 20,
        height: 20,
    },
}));
//# sourceMappingURL=index.js.map